import _ from "lodash";
import { LoadStatus } from "../../enums/enums";
import { getActiveDomain } from "../../helpers/websites/getActiveDomain";
import addNoCacheParamToURL from "../../helpers/editor/addNoCacheParamToURL";

export const getSingleBlogLoadStatus = (blog) => {
  return (dispatch, getState) => {
    const blogs = getState().blogs;
    if (!blog && blogs.dataFetched) {
      return LoadStatus.LOADED;
    }
    if (!blog) {
      return LoadStatus.NO_DATA;
    }
    const currentStatus = blogs.singleBlogLoadStatusArray.find((item) => {
      return item.blogId === blog.id;
    });
    return _.get(currentStatus, "status", LoadStatus.NOT_LOADED);
  };
};

export const previewBlogHomePage = (blogId: number) => {
  return (dispatch, getState) => {
    const blog = getState().blogs.items.find((item) => item.id === blogId);
    if (!blog) return;
    const website = getState().websites.items.find(
      (item) => item.id === blog.website
    );
    if (!website) return;
    let protocol = "https://";
    if (process.env.REACT_APP_API_URL === "http://app.unicorn.com:8000") {
      protocol = "http://";
    }
    let fullUrl = getActiveDomain(website) + "/" + blog.url;
    fullUrl = protocol + fullUrl;
    if (!fullUrl.endsWith("/")) {
      fullUrl += "/";
    }
    window.open(addNoCacheParamToURL(fullUrl), `blogHomePreview-${blogId}`);
  };
};
